// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/shop/components/UsernameCardArt.module.css';
import {usernameCardImageUrl} from '@app/features/shop/utils/UsernameCardImage';

// CSS widths of the art: the shop card and the buy dialog's 18rem visual.
const GRID_CSS_PX = 244;
const FULL_CSS_PX = 288;

interface UsernameCardArtProps {
	length: 1 | 2 | 3;
	asset: string | null;
	// A named username: the name itself, drawn over the card's image.
	name?: string;
	// grid: the shop card's art, which the card lays out; full: the buy dialog's 9:7 box.
	size: 'grid' | 'full';
	animated: boolean;
}

// The card's image, or without one the @ and a place for each character: what is sold is the name itself.
export function UsernameCardArt({length, asset, name, size, animated}: UsernameCardArtProps) {
	return (
		<div className={styles.art} data-size={size} data-named={name !== undefined} data-flx="shop.username-card-art.art">
			{asset ? (
				<img
					className={styles.image}
					src={usernameCardImageUrl(length, asset, size === 'grid' ? GRID_CSS_PX : FULL_CSS_PX, animated)}
					alt=""
					loading="lazy"
					decoding="async"
					draggable={false}
					data-flx="shop.username-card-art.image"
				/>
			) : (
				name === undefined && (
					<span className={styles.placeholder} aria-hidden data-flx="shop.username-card-art.placeholder">
						@{'_'.repeat(length)}
					</span>
				)
			)}
			{name !== undefined && (
				<span className={styles.name} aria-hidden data-flx="shop.username-card-art.name">
					@{name}
				</span>
			)}
		</div>
	);
}
